import { createAction } from 'redux-actions';

export const openQuoteActivityDrawerAction = createAction('DRAWERS/OPEN_QUOTE_ACTIVITY_DRAWER');

export const changeQuoteActivityDrawerParamsAction = createAction(
  'DRAWERS/CHANGE_QUOTE_ACTIVITY_PARAMS',
);
